export default __webpack_public_path__ + "static/media/25A_thumbnail.20566b13.JPG";